import { createActionsHook } from 'src/lib/sweetState';

import { type Actions, BrandBriefsStore, type State } from './BrandBriefsStore';

export const useBrandBriefsActions = createActionsHook<State, Actions>(BrandBriefsStore);
